import {
    AutoComplete,
    Button,
    Col,
    Drawer,
    Form,
    Input, InputNumber, message,
    Row,
    Select,
    Spin
} from "antd";
import {useEffect, useState} from "react";
import reqwest from "reqwest";
import {getToken} from "../../Utils/common";
import {useHistory} from "react-router-dom";
import config from '../../config'


const {Option} = Select;

function Appointment({setAppointmentVisible, visible, appointment_id, refresh_callback, pagination}) {
    const [appointmentForm] = Form.useForm();
    const [visibleSearch, setVisibleSearch] = useState(false)
    const history = useHistory();


    useEffect(() => {
        getAppointment(appointment_id)
    }, []);

    function onClose() {
        setAppointmentVisible(false);
    }

    function onSave() {
        updateAppointment(appointmentForm.getFieldsValue());
    }

    function onDelete() {
        deleteAppointment(appointmentForm.getFieldsValue());
    }

    const getAppointment = (id = 0) => {
        setVisibleSearch(false)
        // setLoading(true);
        // setSpinning(true);
        if (!id) {
            return
        }
        reqwest({
            url: `${config.api_url}/appointments/${id}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            appointmentForm.setFieldsValue(data);
            // Extra data to set in form
            appointmentForm.setFieldsValue({'pacient_copago': data['pacient_copago']})
            // setVisible(true);
            // setSpinning(false);
            // setDisabledDelete(false)
            // setDisabledSave(false)
        }).catch((errorInfo) => {
            //setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener el turno.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);

        });
    };

    const updateAppointment = (appointment = {}) => {
        // setLoadingSaveButton(true);
        let url = "";
        let method = "";

        if (appointment.id > 0) {
            url = config.api_url + '/appointments/' + appointment.id + '/';
            method = 'patch';
        } else {
            return
        }
        // } else {
        //     url = 'http://moravia:8000/appointments/';
        //     method = 'post';
        // }
        reqwest({
            url: url,
            method: method,
            type: 'json',
            data: appointment,
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            // setLoadingSaveButton(false);
            message.success("Actualizacion correcta")
            // if (method == 'post') {
            //     // setVisible(false)
            //     appointmentForm.setFieldsValue(data);
            //     setVisibleSearch(false)
            //     // setDisabledDelete(false)
            // }
            refresh_callback(appointmentForm.getFieldValue('pacient'), {'pagination': pagination})
        }).catch(
            errorInfo => {
                //setLoadingSaveButton(false);
                if (errorInfo.status == 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    const error_detail_obj = JSON.parse(errorInfo.responseText);
                    let error_detail_txt = "";
                    Object.entries(error_detail_obj).forEach(([k, v]) => {
                        error_detail_txt = `${error_detail_txt}${k}\n`;
                        v.forEach((value, i, a) => {
                            error_detail_txt = `${error_detail_txt}(${value})\n`;
                        })
                        error_detail_txt = `${error_detail_txt}\n`;
                    });
                    message.error(`Ha ocurrido un error al intentar guardar el turno.\nStatus: ${errorInfo.status}\nDetalle: ${error_detail_txt}`);
                }
            }
        );
    };

    const deleteAppointment = (appointment = {}) => {
        //setLoadingDeleteButton(true);
        let url = "";
        let method = "";

        url = config.api_url + '/appointments/' + appointment.id + '/';
        method = 'delete';

        reqwest({
            url: url,
            method: method,
            type: 'json',
            data: appointment,
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(_ => {
                //setLoadingDeleteButton(false);
                message.success("Se ha eliminado correctamente")

                appointmentForm.setFieldsValue({"id": 0})
                appointmentForm.setFieldsValue({pacient: ''})
                appointmentForm.setFieldsValue({pacient_search: ''})
                setAppointmentVisible(false)
                refresh_callback(appointment.pacient, {'pagination': pagination})
            }
        ).catch(
            errorInfo => {
                //setLoadingSaveButton(false);
                if (errorInfo.status == 401) {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    history.push('/login');
                } else {
                    const error_detail_obj = JSON.parse(errorInfo.responseText);
                    let error_detail_txt = "";
                    Object.entries(error_detail_obj).forEach(([k, v]) => {
                        error_detail_txt = `${error_detail_txt}${k}\n`;
                        v.forEach((value, i, a) => {
                            error_detail_txt = `${error_detail_txt}(${value})\n`;
                        })
                        error_detail_txt = `${error_detail_txt}\n`;
                    });
                    message.error(`Ha ocurrido un error al intentar eliminar el turno.\nStatus: ${errorInfo.status}\nDetalle: ${error_detail_txt}`);
                }
            }
        );
    };

    return (
        <Drawer
            title="Turno"
            width={"40%"}
            onClose={onClose}
            visible={visible}
            bodyStyle={{paddingBottom: 80}}
            footer={
                <div
                    style={{
                        textAlign: 'right',
                    }}
                >
                    {/*<Button type={"danger"} onClick={onDelete} loading={loadingDeleteButton} disabled={disabledDelete}*/}
                    <Button type={"danger"} onClick={onDelete} style={{marginRight: 8}}>
                        Eliminar
                    </Button>
                    {/*<Button onClick={onSave} type="primary" loading={loadingSaveButton} disabled={disabledSave}>*/}
                    <Button onClick={onSave} type="primary">
                        Guardar
                    </Button>
                </div>
            }
        >
            {/*<Spin spinning={spinning}>*/}
            <Form
                form={appointmentForm}
                layout="vertical" hideRequiredMark
            >
                <Row gutter={16}>
                    <Col span={16}>
                        <Form.Item
                            name="pacient_search"
                            label="Pacientes"
                            style={visibleSearch === true ? {display: "inline"} : {display: "none"}}
                        >
                            <AutoComplete
                                dropdownMatchSelectWidth={252}
                                // style={visibleSearch === true ? {display: "inline"} : {display: "none"}}
                                // options={options}
                                // onSelect={onSelectPacientSearch}
                                // onChange={onChangePacient}
                                // onSearch={handleSearch}
                            >
                                {/*<Input placeholder="Seleccione un paciente" value={autoCompleteText}/>*/}
                            </AutoComplete>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={4}>
                        <Form.Item
                            name="pacient"
                            label="pacient"
                            hidden
                        >
                            <Input hidden defaultValue={appointmentForm.pacient}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            name="present"
                            label="Asistio"
                            rules={[{required: true, message: 'Por favor seleccione si asistio'}]}
                        >
                            <Select placeholder="Por favor seleccione una opcion"
                                    defaultValue={appointmentForm.present}>
                                <Option value="NA">-</Option>
                                <Option value="P">Si</Option>
                                <Option value="A">No</Option>
                                <Option value="AA">No c/aviso</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="attended"
                            label="Atendido"
                            rules={[{required: true, message: 'Por favor seleccione si fue atendido'}]}
                        >
                            <Select placeholder="Por favor seleccione una opcion"
                                    defaultValue={appointmentForm.attended}>
                                <Option value="NA">-</Option>
                                <Option value="Y">Si</Option>
                                <Option value="N">No</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="id"
                            label="id"
                            hidden
                        >
                            <Input hidden defaultValue={appointmentForm.id}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="appointment_at"
                            label="appointment_at"
                            hidden
                        >
                            <Input hidden defaultValue={appointmentForm.appointment_at}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="profesional"
                            label="profesional"
                            hidden
                        >
                            <Input hidden defaultValue={appointmentForm.profesional}/>
                        </Form.Item>
                        <Form.Item
                            name="is_over_shift"
                            label="sobreturno"
                            hidden
                        >
                            <Input hidden defaultValue={appointmentForm.is_over_shift}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            name="modality"
                            label="Modalidad"
                            rules={[{required: true, message: 'Por favor seleccione la modalidad'}]}
                        >
                            <Select placeholder="Por favor seleccione una opcion"
                                    defaultValue={appointmentForm.modality}>
                                <Option value="P">Presencial</Option>
                                <Option value="O">Online</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="motive"
                            label="Motivo"
                            rules={[{required: true, message: 'Por favor seleccione un motivo'}]}
                        >
                            <Select placeholder="Por favor seleccione una opcion" defaultValue={appointmentForm.motive}>
                                <Option value="CA">Consulta</Option>
                                <Option value="AD">Admision</Option>
                                <Option value="RA">Readmision</Option>
                                <Option value="RE">Receta</Option>
                                <Option value="TN">Test Neuro</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={16}>
                        <Form.Item
                            name="detail"
                            label="Detalle Motivo"
                        >
                            <Input.TextArea/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} style={appointmentForm.getFieldValue('pacient_copago') === 'Y' ? {display: "inline"} : {display: "none"}}>
                    <Col span={8}>
                        <Form.Item
                            name="debt_amount"
                            label="Debe"
                        >
                            <InputNumber addonBefore="$" style={{width: 120,}} defaultValue={0}/>
                        </Form.Item>
                    </Col>
                   <Col span={8}>
                      <Form.Item
                        name="payment_method"
                        label="Método de pago"
                        rules={[{ required: true, message: 'Por favor seleccione una opción' }]}
                      >
                      <Select placeholder="Por favor seleccione una opción" defaultValue={appointmentForm.payment_method}>
                        <Option value="NA">-</Option>
                        <Option value="FT">Efectivo</Option>
                        <Option value="MP">Mercado Pago</Option>
                        <Option value="TR">Transferencia</Option>
                        <Option value="OT">Otro</Option>
                      </Select>
                    </Form.Item>
                    </Col>
                </Row>
            </Form>
            {/*</Spin>*/}
        </Drawer>
    )
}

export default Appointment;
